import clsx from 'clsx';
import { Radio } from '../Radio';
import { Typography, TypographyType } from '../Typography';
import { DesignerModalCardProps } from './DesignerModalCard.types';

const DesignerModalCard = ({ id, title, description, isSelected, onSelect }: DesignerModalCardProps) => {
  return (
    <div
      className={clsx('flex cursor-pointer items-center gap-4 rounded-lg p-4', isSelected && 'bg-primary-content')}
      onClick={onSelect}
    >
      <Radio checked={isSelected} value={id} onChange={onSelect} />
      <div className="flex w-full flex-col gap-4">
        {typeof title === 'string' ? <Typography type={TypographyType.H4}>{title}</Typography> : title}
        {description && <Typography type={TypographyType.BASE}>{description}</Typography>}
      </div>
    </div>
  );
};

export default DesignerModalCard;
